import { render, staticRenderFns } from "./SmsManagement.vue?vue&type=template&id=77f92ccc&"
import script from "./SmsManagement.vue?vue&type=script&lang=js&"
export * from "./SmsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports